module.exports = __webpack_public_path__ + "media/images/flags/JP-9de553edbc17f4b342ced148511786f2.svg";